if (signedIn) {
    if (!localStorage.getItem('signedIn')) {
        if (submitTag){
            window.dataLayer.push({
                event: 'user_login_success',
                method: 'email'
            });
        }
        localStorage.setItem('signedIn', true);
    }
} else {
    if (localStorage.getItem('signedIn')) {
        localStorage.removeItem('signedIn');
    }
}

$(document).ready(function() {
    $('#loginBtn').on('click',function(){
        if (submitTag){
            window.dataLayer.push({
                event: 'user_attempt_login',
                method: 'email'
            });
        }
    });
});

if (loginFailed && submitTag){
    window.dataLayer.push({
        event: 'user_login_fail',
        method: 'email'
      });
}